import {forwardRef} from "react";
import "./DialogOfflineAlpha.css"
import {imgPathPerfix} from "@/utils";
import {t} from "i18next";

const DialogOfflineAlpha = forwardRef((props:{onOpenProjectEvent:any}, ref)=>{
    return(
        <div className='div-offline-alpha'>
            <img style={{width: '92px', height: '92px', borderRadius: '53px'}}
                 src={imgPathPerfix() + 'logo.png'}/>
            <span style={{fontFamily: 'PoppinsSemiBold', fontSize: '40px',marginTop:'12px'}}>NOTEEY</span>
            <span style={{fontSize: '17px',marginTop:'12px'}}>{t("All your data is saved locally in the browser")}</span>

            <div className='choose-item ' style={{marginTop: '36px'}} onClick={()=>{
                props.onOpenProjectEvent("newProject")
            }}>
                <img className='img-20' src={imgPathPerfix() + 'offline_add.png'}/>
                <span>{t("Create new project")}</span>
            </div>
            <div className='choose-item' onClick={()=>{
                props.onOpenProjectEvent("openProject")
            }}>
                <img className='img-20' src={imgPathPerfix() + 'offline_open.png'}/>
                <span>{t("Open an existing project")}</span>
            </div>
            <div className='choose-item' onClick={()=>{
                window.open("https://muenzo.com/download","_blank")
            }}>
                <img className='img-20' src={imgPathPerfix() + 'offline_get.png'}/>
                <span>{t("Get Desktop App to Access All Features")}</span>
            </div>
            <div className='choose-item' onClick={()=>{
                window.open("https://muenzo.com/","_blank")
            }}>
                <img className='img-20' src={imgPathPerfix() + 'offline_homepage.png'}/>
                <span>{t("Homepage")}</span>
            </div>


        </div>
    )
})

export default DialogOfflineAlpha;